import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "29d9302d-58bd-45c3-8b3f-8688298ddbb0",
    options: { image: `${config.ASSETS_URL}/02/08/task/task-4-chart-1.svg` },
  },
  {
    id: "10b33769-24bb-41e1-97e5-f880b0075658",
    options: { image: `${config.ASSETS_URL}/02/08/task/task-4-chart-2.svg` },
  },
  {
    id: "1ed7f2c4-43db-4b83-8615-73e3e06e09ae",
    options: { image: `${config.ASSETS_URL}/02/08/task/task-4-chart-3.svg` },
  },
  {
    id: "e22752a5-458e-47fc-95ca-59ce4bb5c9f7",
    options: { image: `${config.ASSETS_URL}/02/08/task/task-4-chart-4.svg` },
  },
];

export const task: Task = {
  id: "35528d93-b799-444e-9718-c639d74fe8d1",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["10b33769-24bb-41e1-97e5-f880b0075658"],
};
